import React, { memo } from 'react';

import { SubNavItem } from '@/components/SideNavigation/types';
import { isEqual } from '@/utils/lodash-alternatives';

import SubNavigationSlot from './SubNavigationSlot';

interface SubNavigationProps {
  items?: SubNavItem[];
  onClick?: (args: { title: string; route_link?: string }) => void;
}

interface SuNavigationItemProps {
  item: SubNavItem;
  index: number;
  onClick?: (args: { title: string; route_link?: string }) => void;
}

const SubNavigationItem: React.FC<SuNavigationItemProps> = memo(
  ({ item, index, onClick }) => {
    const handleItemClick = (e: React.MouseEvent<any>) => {
      e.preventDefault();
      onClick && onClick({ title: item.title, route_link: item.route_link });
    };
    return (
      <div key={item.title} data-testid={`${index}-slot`}>
        <SubNavigationSlot
          data-testid={`subnavigation-slot`}
          item={item}
          onClick={handleItemClick}
        />
      </div>
    );
  },
  (prevProps: SuNavigationItemProps, nextProps: SuNavigationItemProps) =>
    isEqual(prevProps, nextProps)
);

const SubNavigation: React.FC<SubNavigationProps> = ({ items, onClick }) => {
  return (
    <div data-testid="subnavigation-wrapper">
      {items &&
        items.map((item, index) => (
          <SubNavigationItem
            key={item.title}
            item={item}
            index={index}
            onClick={onClick}
          />
        ))}
    </div>
  );
};

export default SubNavigation;
